import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { getUnreadMessageList } from '../../../api/messenger';

import { REQUEST } from '../../../constants/request';

export const fetchUnreadMessages = createAsyncThunk(
  'messenger/fetchUnreadMessages',
  async (args, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });

    try {
      const response = await getUnreadMessageList({
        cancelToken: source.token,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: (arg, { getState }) => {
      const currentLoading =
        getState().messenger.currentLoadings?.unreadConversations ||
        REQUEST.idle;

      return currentLoading !== REQUEST.pending;
    },
  },
);

export const fetchUnreadMessagesExtraReducers = builder => {
  builder
    .addCase(fetchUnreadMessages.pending, (state, { meta }) => {
      state.currentLoadings.unreadConversations = REQUEST.pending;
      state.currentRequestIds.unreadConversations = meta.requestId;
    })
    .addCase(fetchUnreadMessages.fulfilled, (state, { payload }) => {
      state.unreadConversations = payload;
      state.currentLoadings.unreadConversations = REQUEST.idle;
      state.currentRequestIds.unreadConversations = undefined;
    })
    .addCase(fetchUnreadMessages.rejected, (state, { payload }) => {
      state.currentLoadings.unreadConversations = REQUEST.idle;
      state.currentRequestIds.unreadConversations = undefined;
      state.currentErrors.unreadConversations = payload;
    });
};
